import { giphyDarkGrey, giphyIndigo } from '@giphy/js-brand'
import React, { useRef, useState } from 'react'
import CSRFToken from 'shared/components/form/csrftoken-hoc'
import Fields, { FIELDS } from 'shared/components/form/fields'
import { Content, CTAButton as BrandCTAButton, FormContainer, Title } from 'shared/components/form/form-components'
import styled from 'styled-components'

const CTAButton = styled(BrandCTAButton)`
    width: 100%;
`

const PasswordResetForm = ({ csrftoken }) => {
    const form = useRef<HTMLFormElement | null>(null)
    const [submitEnabled, setSubmitEnabled] = useState<boolean>(false)
    return (
        <FormContainer>
            <form action="/password/reset" method="POST" ref={form}>
                {csrftoken && <input type="hidden" name="csrfmiddlewaretoken" value={csrftoken} />}
                <Content>
                    <Title>
                        Reset <br />
                        Password
                    </Title>
                    <Fields onValidChange={setSubmitEnabled} showFields={[FIELDS.email]} />
                    <CTAButton color={submitEnabled ? giphyIndigo : giphyDarkGrey} disabled={!submitEnabled}>
                        Send Email
                    </CTAButton>
                </Content>
            </form>
        </FormContainer>
    )
}

export default CSRFToken(PasswordResetForm)
